import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/sitio-web',
    name: 'sitio-web.editor',
    component: () => import('./views/EditorSitio.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'ajustes.read',
      breadcrumb: 'Sitio web',
    },
  },
]

export default routes
